import { render, staticRenderFns } from "./AfipButtons.vue?vue&type=template&id=a2d434e0&"
import script from "./AfipButtons.vue?vue&type=script&lang=js&"
export * from "./AfipButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports